
const DefaultRequestConst = {
    asc: false,
    limit: 10,
    page: 0,
};

export default DefaultRequestConst;